import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { applianceQueryKeys } from '../QueryKeys';
import { IApplianceSelection } from '../../types/Appliance/Appliance';

export default function useApplianceManufacturers(typeId?: string) {
  const { get } = useApiHelper();

  const applianceManufacturers = useQuery({
    queryKey: applianceQueryKeys.manufacturers(typeId),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceSelection>>(
        `/v1/hardware/manufacturers${typeId !== undefined ? `/${typeId}` : ''}`
      ).then((res) => res.data.data),
  });

  return {
    applianceManufacturers,
  };
}
